var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAyudaDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.660377,
    y: 0.660377,
    width: 37.6792,
    height: 37.6792,
    rx: 18.8396,
    stroke: "white",
    strokeWidth: 1.32075
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.7842 27.8364H21.575L16.8924 30.9512C16.1979 31.4142 15.2614 30.9196 15.2614 30.0778V27.8364C12.1046 27.8364 10 25.7319 10 22.575V16.2614C10 13.1046 12.1046 11 15.2614 11H25.7842C28.941 11 31.0455 13.1046 31.0455 16.2614V22.575C31.0455 25.7319 28.941 27.8364 25.7842 27.8364Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5228 21.1857C20.0913 21.1857 19.7336 20.828 19.7336 20.3965V20.1756C19.7336 18.9549 20.628 18.3551 20.9647 18.1236C21.3541 17.8606 21.4803 17.6817 21.4803 17.4081C21.4803 16.882 21.0489 16.4505 20.5228 16.4505C19.9966 16.4505 19.5652 16.882 19.5652 17.4081C19.5652 17.8395 19.2075 18.1973 18.776 18.1973C18.3446 18.1973 17.9868 17.8395 17.9868 17.4081C17.9868 16.0086 19.1232 14.8721 20.5228 14.8721C21.9223 14.8721 23.0587 16.0086 23.0587 17.4081C23.0587 18.6077 22.1749 19.2075 21.8487 19.4284C21.4383 19.702 21.312 19.8809 21.312 20.1756V20.3965C21.312 20.8385 20.9542 21.1857 20.5228 21.1857Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyudaDark);
export default __webpack_public_path__ + "static/media/ayuda-dark.097090f132d3948e808d1f369959f872.svg";
export { ForwardRef as ReactComponent };